module.exports = __webpack_public_path__ + "img/next-steps-2.87a76fa1.png";